import { createReducer } from 'redux-starter-kit';
import {
  CREATE_CASE,
  SET_CASE_INFO,
  SET_EXECUTIVE_SUMMARY,
  SET_IS_LOADING_CASE_INFO,
  SET_LINKED_CUSTOMERS_TO_CASE,
  SET_IS_CASE_INFO_LOADED,
  CLEAR_CASE,
  SET_HAS_EXISTING_POLICIES,
  SET_NEXT_PAGE,
  SET_RISK_SUMMARIES,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  CLEAR_EXISTING_POLICIES,
  SET_EXISTING_POLICIES,
  ADD_NEW_EXISTING_POLICY,
  REMOVE_EXISTING_POLICY,
  MARK_AS_SAVED,
  SET_AGGREGATE_COST_AND_CHARGES,
  SET_ALL_AGGREGATE_COST_AND_CHARGES,
  SET_AGGREGATE_COST_AND_CHARGES_TABLE,
  SET_AGGREGATE_DATA_FOR_POLICIES,
  SET_ASSET_ALLOCATION_EVALUE,
  SET_ASSET_ALLOCATIONS,
  SET_COUNTRY_BREAKDOWN,
  SET_EXISITNG_POLICIES_RISK_SCORE,
  SET_EXISTING_POLICIES_CHARGES,
  SET_EXISTING_POLICIES_PERFORMANCE,
  SET_PAST_PERFORMANCE,
  SET_PAST_PERFORMANCE_AGGREGAGES,
  SET_PORTFOLIO_RISK_SCORE,
  SET_PORTFOLIO_SPLIT,
  SET_RECOMMENDED_POLICIES_CHARGES,
  SET_RECOMMENDED_POLICIES_RISK_SCORE,
  SET_REGIONAL_BREAKDOWN,
  SET_SECTOR_BREAKDOWN,
  SET_TOTAL_ONGOING_CHARGES,
  SET_TOTAL_PERFORMANCE_DATA,
  UPDATE_EXISTING_POLICY,
  INVALIDATE_STORE_SUBSET,
  SET_WITHDRAWALS,
  SET_POLICIES,
  UPDATE_POLICIE,
  SET_CONTRIBUTIONS,
  SET_CONTRIBUTIONS_SUMMARY,
  SET_EXISTING_ASSET_ALLOCATIONS,
  SET_EXISTING_COUNTRY_BREAKDOWN,
  SET_EXISTING_REGIONAL_BREAKDOWN,
  SET_EXISTING_SECTOR_BREAKDOWN,
  SET_HOLDINGS,
  SET_PROVIDERS,
  SET_APPLIED_ADVISOR_CHARGES,
  SET_EXISTING_RISK_ANALYSIS,
  SET_RECOMMENDED_RISK_ANALYSIS
} from './actions';
import { CustomerType } from 'store/modules/Customers/types';
import {
  AggregateCostAndChargesPoliciesType,
  AggregateCostAndChargesTypes,
  AssetAllocationEvalueType,
  AssetAllocationTypeChartData,
  ExistingPoliciesRiskScores,
  PastPerformanceAggregateType,
  PastPerformanceTypeChartData,
  PolicyChargeTypeChartData,
  PolicyRiskScore,
  PortfolioSplitTypeChartData,
  RecommendedPoliciesRiskScores,
  TotalOngoingChargeTypeChartData
} from '../Charts/types';
import { PolicyType } from '../Policies/types';
import { ContributionSummaryType } from '../Contributions/types';
import { PlatformType } from '../Platform/types';

export interface CaseState {
  isLoadingCaseInfo: boolean;
  isCaseInfoLoaded: boolean;
  id: number | null;
  pid: string | null;
  name: string | null;
  customers: Array<CustomerType>;
  hasExistingPolicies: boolean;
  executiveSummary: string | null;
  riskProfiler: any;
  riskGroup: any;
  questionnaireLength: any;
  notes: any;
  nextPage: any;
  riskSummaries: any;
  existingPolicies: any;
  status: any;
  pastPerformance: Array<PastPerformanceTypeChartData>;
  assetAllocations: Array<AssetAllocationTypeChartData>;
  existingAssetAllocations: Array<AssetAllocationTypeChartData>;
  sectorBreakdown: any[];
  countryBreakdown: any;
  regionlBreakdown: any;
  existingSectorBreakdown: any[];
  existingCountryBreakdown: any;
  existingRegionlBreakdown: any;
  existingPoliciesCharges: Array<PolicyChargeTypeChartData>;
  recommendedPoliciesCharges: Array<PolicyChargeTypeChartData>;
  portfolioSplit: Array<PortfolioSplitTypeChartData>;
  totalOngoingCharges: Array<TotalOngoingChargeTypeChartData>;
  portfolioRiskScore: Array<PolicyRiskScore>;
  existingPoliciesRiskScore: Array<ExistingPoliciesRiskScores>;
  recommendedPoliciesRiskScore: Array<RecommendedPoliciesRiskScores>;
  pastPerformanceAggregates: Array<PastPerformanceAggregateType>;
  aggregateCostAndCharges: Array<AggregateCostAndChargesTypes>;
  aggregateCostAndChargesPolicies: AggregateCostAndChargesPoliciesType[];
  aggregateCostAndChargesPolicyTable: any[];
  allAggregateCostAndCharges: any;
  assetAllocationEvalue: AssetAllocationEvalueType[];
  existingPoliciesPerformance: any[];
  totalPerformanceData: any[];
  withdrawals: any;
  policies: any;
  contributions: any;
  contributionsSummary: ContributionSummaryType;
  holdings: any;
  providers: { platforms: PlatformType[] };
  advisorChargesSummary: any;
  appliedCharges: any[];
  existingRiskAnalysis: any[];
  recommendedRiskAnalysis: any[];
}

const paginatedData = {
  count: null,
  next: null,
  previous: null,
  results: []
};

const countryBreakdownData = {
  equity: [],
  fixed_income: []
};

export const INITIAL_STATE = {
  isLoadingCaseInfo: false,
  isCaseInfoLoaded: false,
  id: null,
  pid: null,
  name: null,
  customers: [],
  hasExistingPolicies: false,
  executiveSummary: null,
  riskProfiler: 'EValue',
  riskGroup: null,
  questionnaireLength: 25,
  notes: null,
  nextPage: null,
  riskSummaries: paginatedData,
  existingPolicies: paginatedData,
  withdrawals: paginatedData,
  policies: paginatedData,
  contributions: paginatedData,
  contributionsSummary: {
    unallocated_existing: 0,
    unallocated_existing_percentage: 0,
    unallocated_new_lump: 0,
    unallocated_new_lump_percentage: 0,
    unallocated_new_regular: 0,
    unallocated_new_regular_percentage: 0
  },
  allAggregateCostAndCharges: {},
  status: {},
  pastPerformance: [],
  assetAllocations: [],
  existingAssetAllocations: [],
  sectorBreakdown: [],
  countryBreakdown: countryBreakdownData,
  regionlBreakdown: countryBreakdownData,
  existingSectorBreakdown: [],
  existingCountryBreakdown: countryBreakdownData,
  existingRegionlBreakdown: countryBreakdownData,
  existingPoliciesCharges: [],
  recommendedPoliciesCharges: [],
  portfolioSplit: [],
  totalOngoingCharges: [],
  portfolioRiskScore: [],
  existingPoliciesRiskScore: [],
  recommendedPoliciesRiskScore: [],
  pastPerformanceAggregates: [],
  aggregateCostAndCharges: [],
  aggregateCostAndChargesPolicies: [],
  assetAllocationEvalue: [],
  aggregateCostAndChargesPolicyTable: [],
  existingPoliciesPerformance: [],
  totalPerformanceData: [],
  holdings: [],
  providers: { platforms: [] },
  advisorChargesSummary: {
    unallocated_initial: 0,
    unallocated_initial_percentage: 0,
    unallocated_ongoing: 0,
    unallocated_ongoing_percentage: 0
  },
  appliedCharges: [],
  existingRiskAnalysis: [],
  recommendedRiskAnalysis: []
} as CaseState;

export default createReducer(INITIAL_STATE, {
  [CREATE_CASE]: (state, action) => {
    state.id = action.payload.id;
    state.pid = action.payload.pid;
    state.name = action.payload.name;
    state.executiveSummary = action.payload.executive_summary;
  },
  [SET_IS_LOADING_CASE_INFO]: (state, action) => {
    state.isLoadingCaseInfo = action.payload;
  },
  [SET_IS_CASE_INFO_LOADED]: (state, action) => {
    state.isCaseInfoLoaded = action.payload;
  },
  [SET_EXECUTIVE_SUMMARY]: (state, action) => {
    state.executiveSummary = action.payload;
  },
  [SET_CASE_INFO]: (state, action) => {
    state.id = action.payload.data.id;
    state.pid = action.payload.data.pid;
    state.name = action.payload.data.name;
    state.executiveSummary = action.payload.data.executive_summary;
    state.riskProfiler = action.payload.data.risk_profiler;
    state.riskGroup = action.payload.data.risk_group;
    state.questionnaireLength = action.payload.data.questionnaire_length;
    state.notes = action.payload.data.notes;
  },
  [SET_LINKED_CUSTOMERS_TO_CASE]: (state, action) => {
    state.customers = action.payload.data.results;
  },
  [CLEAR_CASE]: () => INITIAL_STATE,
  [SET_HAS_EXISTING_POLICIES]: (state, action) => {
    state.hasExistingPolicies = action.payload;
  },
  [SET_NEXT_PAGE]: (state, action) => {
    state.nextPage = action.payload;
  },
  [SET_RISK_SUMMARIES]: (state, action) => {
    state.riskSummaries = action.payload;
  },
  [SET_EXISTING_POLICIES]: (state, action) => {
    state.existingPolicies = action.payload;
  },
  [SET_WITHDRAWALS]: (state, action) => {
    state.withdrawals = action.payload;
  },
  [CLEAR_EXISTING_POLICIES]: state => {
    state.existingPolicies = paginatedData;
  },
  [ADD_NEW_EXISTING_POLICY]: (state, action) => {
    const res = state.existingPolicies.results.slice();
    res.push(action.payload);
    state.existingPolicies.results = res;
  },
  [REMOVE_EXISTING_POLICY]: (state, action) => {
    const res = [...state.existingPolicies.results];
    res.splice(action.payload, 1);
    state.existingPolicies.results = res;
  },
  [MARK_AS_SAVED]: (state, action) => {
    const res = [...state.existingPolicies.results];
    res.pop();
    res.push(action.payload);

    state.existingPolicies.results = res;
  },
  [UPDATE_EXISTING_POLICY]: (state, action) => {
    const res = [...state.existingPolicies.results];
    res.splice(
      res.findIndex(policy => policy.id === action.payload.id),
      1,
      action.payload
    );
    state.existingPolicies.results = res;
  },
  [SET_PAST_PERFORMANCE]: (state, { payload }) => {
    state.pastPerformance = payload;
  },
  [SET_EXISTING_ASSET_ALLOCATIONS]: (state, { payload }) => {
    state.existingAssetAllocations = payload.filter(
      (allocation: any) => allocation.Existing !== 0
    );
  },
  [SET_ASSET_ALLOCATIONS]: (state, { payload }) => {
    state.assetAllocations = payload;
  },
  [SET_SECTOR_BREAKDOWN]: (state, { payload }) => {
    state.sectorBreakdown = payload;
  },
  [SET_COUNTRY_BREAKDOWN]: (state, { payload }) => {
    state.countryBreakdown = payload;
  },
  [SET_REGIONAL_BREAKDOWN]: (state, { payload }) => {
    state.regionlBreakdown = payload;
  },
  [SET_EXISTING_SECTOR_BREAKDOWN]: (state, { payload }) => {
    state.existingSectorBreakdown = payload;
  },
  [SET_EXISTING_COUNTRY_BREAKDOWN]: (state, { payload }) => {
    state.existingCountryBreakdown = payload;
  },
  [SET_EXISTING_REGIONAL_BREAKDOWN]: (state, { payload }) => {
    state.existingRegionlBreakdown = payload;
  },
  [SET_EXISTING_POLICIES_CHARGES]: (state, { payload }) => {
    state.existingPoliciesCharges = payload;
  },
  [SET_EXISTING_POLICIES_PERFORMANCE]: (state, { payload }) => {
    state.existingPoliciesPerformance = payload;
  },
  [SET_RECOMMENDED_POLICIES_CHARGES]: (state, { payload }) => {
    state.recommendedPoliciesCharges = payload;
  },
  [SET_PORTFOLIO_SPLIT]: (state, { payload }) => {
    state.portfolioSplit = payload;
  },
  [SET_TOTAL_ONGOING_CHARGES]: (state, { payload }) => {
    state.totalOngoingCharges = payload;
  },
  [SET_TOTAL_PERFORMANCE_DATA]: (state, { payload }) => {
    state.totalPerformanceData = payload;
  },
  [SET_PORTFOLIO_RISK_SCORE]: (state, { payload }) => {
    state.portfolioRiskScore = payload;
  },
  [SET_EXISITNG_POLICIES_RISK_SCORE]: (state, { payload }) => {
    state.existingPoliciesRiskScore = payload;
  },
  [SET_RECOMMENDED_POLICIES_RISK_SCORE]: (state, { payload }) => {
    state.recommendedPoliciesRiskScore = payload;
  },
  [SET_PAST_PERFORMANCE_AGGREGAGES]: (state, { payload }) => {
    state.pastPerformanceAggregates = payload;
  },
  [SET_AGGREGATE_COST_AND_CHARGES]: (state, { payload }) => {
    state.aggregateCostAndCharges = payload.data;
    const cachedData = {
      ...state[`allAggregateCostAndCharges.${payload.id}` as keyof CaseState]
    };
    state[`allAggregateCostAndCharges.${payload.id}` as keyof CaseState] = {
      ...cachedData,
      chart: payload.data
    };
  },
  [SET_ALL_AGGREGATE_COST_AND_CHARGES]: (state, { payload }) => {
    state.allAggregateCostAndCharges = payload;
  },
  [SET_AGGREGATE_DATA_FOR_POLICIES]: (state, { payload }) => {
    state.aggregateCostAndChargesPolicies = payload;
  },
  [SET_ASSET_ALLOCATION_EVALUE]: (state, { payload }) => {
    state.assetAllocationEvalue = payload;
  },
  [SET_AGGREGATE_COST_AND_CHARGES_TABLE]: (state, { payload }) => {
    state.aggregateCostAndChargesPolicyTable = payload.data;
    const cachedData = {
      ...state[`allAggregateCostAndCharges.${payload.id}` as keyof CaseState]
    };
    state[`allAggregateCostAndCharges.${payload.id}` as keyof CaseState] = {
      ...cachedData,
      table: payload.data
    };
  },
  [SET_POLICIES]: (state, action) => {
    state.policies = action.payload;
  },
  [UPDATE_POLICIE]: (state, { payload }) => {
    const policies = [...state.policies.results];
    const policyToUpdateIndex = policies.findIndex(
      (policy: PolicyType) => policy.id === payload.id
    );

    policies.splice(policyToUpdateIndex, 1, payload);

    state.policies.results = policies;
  },
  [SET_CONTRIBUTIONS]: (state, action) => {
    state.contributions = action.payload;
  },
  [SET_CONTRIBUTIONS_SUMMARY]: (state, action) => {
    if (!action.payload) {
      return;
    }

    state.contributionsSummary.unallocated_existing =
      action.payload.unallocated_existing.unallocated_amount;
    state.contributionsSummary.unallocated_existing_percentage =
      action.payload.unallocated_existing.unallocated_percentage * 100;
    state.contributionsSummary.unallocated_new_lump =
      action.payload.unallocated_new_lump.unallocated_amount;
    state.contributionsSummary.unallocated_new_lump_percentage =
      action.payload.unallocated_new_lump.unallocated_percentage * 100;
    state.contributionsSummary.unallocated_new_regular =
      action.payload.unallocated_new_regular.unallocated_amount;
    state.contributionsSummary.unallocated_new_regular_percentage =
      action.payload.unallocated_new_regular.unallocated_percentage * 100;
  },
  [SET_HOLDINGS]: (state, action) => {
    state.holdings = action.payload;
  },
  [SET_PROVIDERS]: (state, action) => {
    state.providers = action.payload;
  },
  [SET_APPLIED_ADVISOR_CHARGES]: (state, action) => {
    state.appliedCharges = action.payload;
  },
  [FETCH_START]: (state, action) => ({
    ...state,
    status: { ...state.status, [action.payload.key]: 'loading' }
  }),
  [FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      [action.payload.key]: action.payload.data,
      status: { ...state.status, [action.payload.key]: 'succeeded' }
    };
  },
  [FETCH_FAILURE]: (state, action) => ({
    ...state,
    status: { ...state.status, [action.payload.key]: 'failed' }
  }),
  [INVALIDATE_STORE_SUBSET]: (state, action) => {
    const newStatus = { ...state.status };
    action.payload.forEach((key: string) => {
      delete newStatus[key];
    });
    return {
      ...state,
      status: newStatus
    };
  },
  [SET_EXISTING_RISK_ANALYSIS]: (state, { payload }) => {
    state.existingRiskAnalysis = payload;
  },
  [SET_RECOMMENDED_RISK_ANALYSIS]: (state, { payload }) => {
    state.recommendedRiskAnalysis = payload;
  }
});
